// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background-color: #ffffff;
  color: #111827;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: #f3f4f6;
}
::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

/* Focus styles */
input:focus, textarea:focus, select:focus {
  border-color: #4f46e5 !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

/* Links */
a {
  transition: opacity 0.2s;
}

a:hover {
  opacity: 0.85;
}

/* Button hover */
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ═══ Grammar Error Highlighting ═══ */

/* Spelling errors - Orange/Yellow wavy underline */
.spelling-error {
  background-color: rgba(251, 191, 36, 0.15);
  border-bottom: 2px wavy #f59e0b;
  padding: 2px 0;
  cursor: help;
  position: relative;
  transition: background-color 0.2s ease;
}

.spelling-error:hover {
  background-color: rgba(251, 191, 36, 0.3);
}

/* Grammar errors - Red wavy underline */
.grammar-error {
  background-color: rgba(239, 68, 68, 0.12);
  border-bottom: 2px wavy #dc2626;
  padding: 2px 0;
  cursor: help;
  position: relative;
  transition: background-color 0.2s ease;
}

.grammar-error:hover {
  background-color: rgba(239, 68, 68, 0.25);
}

/* Tooltip effect on title attribute */
.spelling-error::before,
.grammar-error::before {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: #1f2937;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 1000;
  max-width: 250px;
  white-space: normal;
  text-align: center;
}

.spelling-error:hover::before,
.grammar-error:hover::before {
  opacity: 1;
  transform: translateX(-50%) translateY(-4px);
}

/* Arrow for tooltip */
.spelling-error::after,
.grammar-error::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1f2937;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.spelling-error:hover::after,
.grammar-error:hover::after {
  opacity: 1;
}

/* ═══ Quill Editor Overrides ═══ */
.ql-container.ql-snow { border: none !important; height: 100% !important; }
.ql-editor {
  padding: 0 !important;
  font-size: 17px !important;
  line-height: 1.85 !important;
  color: #1e293b !important;
  font-family: 'Inter', -apple-system, sans-serif !important;
  min-height: 100%;
  outline: none !important;
}
.ql-editor.ql-blank::before {
  color: #94a3b8 !important;
  font-style: normal !important;
  font-size: 17px !important;
}
/* Grammar underline blot */
span[data-grammar-error] {
  text-decoration-line: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #ef4444 !important;
  text-decoration-thickness: 2px !important;
  text-underline-offset: 3px !important;
  border-bottom: 2px solid #ef4444 !important;
  background-color: rgba(239, 68, 68, 0.06) !important;
  cursor: pointer !important;
}

span[data-spell-error] {
  text-decoration-line: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #2563eb !important;
  text-decoration-thickness: 2px !important;
  text-underline-offset: 3px !important;
  border-bottom: 2px solid #2563eb !important;
  background-color: rgba(37, 99, 235, 0.06) !important;
  cursor: pointer !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;EAC/E,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,UAAU;AACV;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uCAAuC;;AAEvC,mDAAmD;AACnD;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wCAAwC;AACxC;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sCAAsC;AACtC;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,kDAAkD;EAClD,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA,mCAAmC;AACnC,wBAAwB,uBAAuB,EAAE,uBAAuB,EAAE;AAC1E;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,0DAA0D;EAC1D,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA,2BAA2B;AAC3B;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,yCAAyC;EACzC,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;EAC3C,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,yCAAyC;EACzC,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;EAC3C,oDAAoD;EACpD,0BAA0B;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background-color: #ffffff;\n  color: #111827;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n}\n::-webkit-scrollbar-track {\n  background: #f3f4f6;\n}\n::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease-out forwards;\n}\n\n/* Focus styles */\ninput:focus, textarea:focus, select:focus {\n  border-color: #4f46e5 !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n/* Links */\na {\n  transition: opacity 0.2s;\n}\n\na:hover {\n  opacity: 0.85;\n}\n\n/* Button hover */\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ═══ Grammar Error Highlighting ═══ */\n\n/* Spelling errors - Orange/Yellow wavy underline */\n.spelling-error {\n  background-color: rgba(251, 191, 36, 0.15);\n  border-bottom: 2px wavy #f59e0b;\n  padding: 2px 0;\n  cursor: help;\n  position: relative;\n  transition: background-color 0.2s ease;\n}\n\n.spelling-error:hover {\n  background-color: rgba(251, 191, 36, 0.3);\n}\n\n/* Grammar errors - Red wavy underline */\n.grammar-error {\n  background-color: rgba(239, 68, 68, 0.12);\n  border-bottom: 2px wavy #dc2626;\n  padding: 2px 0;\n  cursor: help;\n  position: relative;\n  transition: background-color 0.2s ease;\n}\n\n.grammar-error:hover {\n  background-color: rgba(239, 68, 68, 0.25);\n}\n\n/* Tooltip effect on title attribute */\n.spelling-error::before,\n.grammar-error::before {\n  content: attr(title);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: #1f2937;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  z-index: 1000;\n  max-width: 250px;\n  white-space: normal;\n  text-align: center;\n}\n\n.spelling-error:hover::before,\n.grammar-error:hover::before {\n  opacity: 1;\n  transform: translateX(-50%) translateY(-4px);\n}\n\n/* Arrow for tooltip */\n.spelling-error::after,\n.grammar-error::after {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1f2937;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.spelling-error:hover::after,\n.grammar-error:hover::after {\n  opacity: 1;\n}\n\n/* ═══ Quill Editor Overrides ═══ */\n.ql-container.ql-snow { border: none !important; height: 100% !important; }\n.ql-editor {\n  padding: 0 !important;\n  font-size: 17px !important;\n  line-height: 1.85 !important;\n  color: #1e293b !important;\n  font-family: 'Inter', -apple-system, sans-serif !important;\n  min-height: 100%;\n  outline: none !important;\n}\n.ql-editor.ql-blank::before {\n  color: #94a3b8 !important;\n  font-style: normal !important;\n  font-size: 17px !important;\n}\n/* Grammar underline blot */\nspan[data-grammar-error] {\n  text-decoration-line: underline !important;\n  text-decoration-style: solid !important;\n  text-decoration-color: #ef4444 !important;\n  text-decoration-thickness: 2px !important;\n  text-underline-offset: 3px !important;\n  border-bottom: 2px solid #ef4444 !important;\n  background-color: rgba(239, 68, 68, 0.06) !important;\n  cursor: pointer !important;\n}\n\nspan[data-spell-error] {\n  text-decoration-line: underline !important;\n  text-decoration-style: solid !important;\n  text-decoration-color: #2563eb !important;\n  text-decoration-thickness: 2px !important;\n  text-underline-offset: 3px !important;\n  border-bottom: 2px solid #2563eb !important;\n  background-color: rgba(37, 99, 235, 0.06) !important;\n  cursor: pointer !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
